import styled, { css } from "styled-components";
import { color, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
import { Field } from "../field/Field";
export const ColorFieldColorSwatchWrapper = styled.span `
  display: block;
`;
export const ColorField = styled(Field) `
  display: ${({ layoutVariant }) => (layoutVariant === "inline" ? "inline-flex" : "inline-block")};

  input::-ms-clear {
    display: none;
  }
`;
export const ColorFieldColorSwatch = styled.div `
  min-width: ${units(2.5)};
  width: ${units(2.5)};
  height: ${units(2.5)};
  border-radius: 50%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  position: relative;
`;
export const ColorFieldVisuallyHiddenText = styled.div `
  ${visuallyHidden()};
`;
export const ColorFieldRgbaWrapper = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0;

  input {
    width: 100%;
    min-width: 20px;
    border-radius: 0;
    padding-right: 0;
    padding-left: 0;
    text-align: center;
  }

  label {
    ${({ hasVariantLabel }) => (hasVariantLabel ? css `` : visuallyHidden())}
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
  }

  div:first-child input {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }

  div:nth-child(4) input {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
  }
`;
export const ColorFieldRgbaWrapperControl = styled.div `
  grid-column-start: 5;
  grid-row-start: 1;
  grid-row-end: 9;
  align-items: flex-start;
  padding: 5px;
`;
const colorFieldVariantTextCSS = css `
  color: ${color("typeMeta")};
  ${typeStyle("bodyS")}
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  /* Inputs are number inputs so the text isn't exactly centered in the input
     This will line up the text with the input text*/
  padding-right: ${units(2)};
`;
export const ColorFieldVariantText = styled.div `
  ${colorFieldVariantTextCSS}
`;
export const RGBAInputLabel = styled.label `
  ${colorFieldVariantTextCSS}
`;
